import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import { BriefcaseFill, GeoAltFill, ClockFill } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

function Career() {
  const [show, setShow] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const navigate = useNavigate();

  const jobs = [
    {
      title: "React JS Developer",
      location: "Pune, India",
      type: "Full Time",
      experience: "1-3 Years",
      description:
        "We are looking for a skilled React Developer to join our dynamic team.",
      requirements: [
        "Strong knowledge of React JS",
        "Experience with REST APIs",
        "Good understanding of HTML, CSS, JavaScript",
        "Team player with problem-solving skills",
      ],
    },
    {
      title: "ASP.NET Developer",
      location: "Remote",
      type: "Full Time",
      experience: "2-5 Years",
      description:
        "Looking for experienced ASP.NET developer with strong backend knowledge.",
      requirements: [
        "Strong knowledge of ASP.NET & C#",
        "Experience with SQL Server",
        "Knowledge of Web API",
        "Good debugging skills",
      ],
    },
  ];

  const handleShow = (job) => {
    setSelectedJob(job);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <>

    <SEO
  title="Careers at Uiplus Technologies | Software Jobs in Pune"
  description="Join Uiplus Technologies and build your career in software development and ERP solutions."
  keywords="Software Jobs in Pune, React Developer Jobs, ASP.NET Jobs, IT Company Careers"
  url="https://uiplus.in/career"
/>
      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #0d6efd, #6610f2)",
          color: "white",
          padding: "70px 0",
          textAlign: "center",
        }}
      >
        <Container>
          <h1 className="fw-bold">Join Uiplus Technologies</h1>
          <p className="mt-3">
            Build your career with innovation, creativity and growth.
          </p>
        </Container>
      </div>

      {/* Open Positions */}
      <Container className="my-5">
        <h2 className="text-center mb-4 fw-bold">Current Openings</h2>

        <Row>
          {jobs.map((job, index) => (
            <Col md={6} className="mb-4" key={index}>
              <Card className="shadow-lg border-0 h-100 rounded-4">
                <Card.Body>
                  <Card.Title className="fw-bold">
                    <BriefcaseFill className="me-2 text-primary" />
                    {job.title}
                  </Card.Title>

                  <p className="text-muted">
                    <GeoAltFill className="me-1" /> {job.location} |{" "}
                    <ClockFill className="me-1" /> {job.type}
                  </p>

                  <p>{job.description}</p>

                  <Button
                    variant="primary"
                    onClick={() => handleShow(job)}
                    className="rounded-pill px-4"
                  >
                    View Details
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Job Detail Modal */}
      {selectedJob && (
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>{selectedJob.title}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p><strong>Location:</strong> {selectedJob.location}</p>
            <p><strong>Experience:</strong> {selectedJob.experience}</p>
            <p>{selectedJob.description}</p>

            <h6 className="mt-3">Requirements:</h6>
            <ul>
              {selectedJob.requirements.map((req, i) => (
                <li key={i}>{req}</li>
              ))}
            </ul>
          </Modal.Body>

          <Modal.Footer>
            <Button
  variant="primary"
  className="rounded-pill px-4"
  onClick={() => navigate("/apply")}
>
  Apply Now
</Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}

export default Career;
